import { module } from 'modujs';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default class extends module {
    constructor(m) {
        super(m);

        this.length = this.$('item').length
        this.$container = this.$('container')[0];
        this.$prev = this.$('prev')[0];
        this.$next = this.$('next')[0];
    }

    init() {
        const args = {
            modules: [Navigation],
            speed: 700,
            a11y: true,
            loop: false,
            centeredSlides: false,
            grabCursor: true,
            slidesPerView: 1.2,
            spaceBetween: 20,
            navigation: {
                nextEl: this.$next,
                prevEl: this.$prev,
            },
            breakpoints: {
                700: {
                    slidesPerView: 2
                },
                900: {
                    slidesPerView: 3
                },
                1000: {
                    slidesPerView: 4
                },
            }
        }

        // Init carousel only if it meets one of these condition
        if (this.length > 1) {
            this.carousel = new Swiper(this.$container, args)
        }
    }

    destroy() {
        super.destroy()
        this.carousel?.destroy(true, true)
    }
}
